import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import pexels from '../util/pexels'
import { updateStatus } from '../root/actions'
import { RESULTS_FOUND } from '../root/constants'

const searchCall = async ({ query, page = 1 }, { dispatch }) => {
  const response = await pexels.search.getPhotos({
    query,
    page,
    per_page: 12,
    orientation: 'landscape',
  })
  dispatch(
    updateStatus(RESULTS_FOUND(response.response.total_results, query, page))
  )

  return response.response
}

export const search = createAsyncThunk('images/search', searchCall)

export const clearImages = createAction('images/clear')
